export const MAXIMUM_ROWS_TO_DISPLAY = 20;
